import type { ExperimentConfig } from '@seek/candidate-feature-flag';

import {
  AUTO_FOCUS_WHERE_FEATURE_FLAG,
  REFINE_BAR_V2_FEATURE_FLAG,
  SAVED_RECENT_SEARCHES_FEATURE_FLAG,
} from './featureFlags';

// It's advisable to define each experiment in a separate const and then add it to
// the experimentsToFetch array.
// This is to make it easier to use the experiments hooks later in components
//
// For example:
//  const experimentObject = {
//    key: 'experiment-key',
//    trackingNumber: 1,
//  };
//  const experimentsToFetch = [experimentObject, ...];
//
// Then in the component:
//  const { value } = useExperimentValue(experimentObject.key)
//  if (value === 'variant') { ... } else { ... }

/**
 * Add all experiments for all pages to this array.
 * This is what is being used to call Feature Flags Query (LaunchDarkly)
 */

const refineBarV2Experiment = {
  key: REFINE_BAR_V2_FEATURE_FLAG,
  trackingNumber: 65,
};

const autoFocusWhereExperiment = {
  key: AUTO_FOCUS_WHERE_FEATURE_FLAG,
  trackingNumber: 65,
};

const savedRecentSearchesExperiment = {
  key: SAVED_RECENT_SEARCHES_FEATURE_FLAG,
  trackingNumber: 65,
};

export const experimentsToFetch: ExperimentConfig[] = [
  refineBarV2Experiment,
  autoFocusWhereExperiment,
  savedRecentSearchesExperiment,
];
